export default function assetPath(url: string): string {
  if (url.startsWith('http')) return url;

  const assetsDomain = process.env.NEXT_PUBLIC_ASSETS_DOMAIN || '';
  return assetsDomain + '/' + url.replace(/^\//, '');
}
